import {
  setScheduleTourShowModal,
  setScheduleTourStep,
  selectScheduleTourStep,
} from 'src/store/slices/scheduleTour'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Button, Text } from 'src/Components'
import { IconArrowLeft } from 'src/Components/shared/Icon'
import { useDispatch, useSelector } from 'react-redux'
import { STEPS } from 'src/store/slices/scheduleTour'
import React from 'react'
import styles from './StepHeaderNavSection.module.scss'

export interface StepHeaderProps {
  children?: React.ReactNode
}

const StepHeader = ({ children }: StepHeaderProps) => {
  const dispatch = useDispatch()
  const currentStep = useSelector(selectScheduleTourStep)
  const stepIndex = STEPS.indexOf(currentStep)

  return (
    <div className={styles.header}>
      <Button
        className={classnames(
          styles.backButton,
          (stepIndex === 0 || stepIndex === STEPS.length - 1) && styles.hidden
        )}
        iconStart={IconArrowLeft}
        onClick={() => dispatch(setScheduleTourStep(STEPS[stepIndex - 1]))}
        minimal
      >
        <FormattedMessage id='Buttons.navigation.back' defaultMessage='Back' />
      </Button>
      <Text
        variant='neutralCool'
        variantCount='900'
        align='center'
        element='h3'
        weight='semibold'
        size='m'
      >
        {!children && (
          <FormattedMessage
            id='ScheduleTour.stepProgressCounter'
            defaultMessage='Step {currentStep} of {totalSteps}'
            values={{
              currentStep: stepIndex + 1,
              // technically there are 5 steps, but last step is just a confirmation screen, so we want to display "step x of 4"
              totalSteps: STEPS.length - 1,
            }}
          />
        )}
        {children}
      </Text>
      <Button
        minimal
        className={classnames(
          styles.cancelButton,
          stepIndex === STEPS.length - 1 && styles.hidden
        )}
        onClick={() => dispatch(setScheduleTourShowModal(false))}
      >
        <FormattedMessage
          id='HomeSearch.listings.alerts.modal.cancel'
          defaultMessage='Cancel'
        />
      </Button>
    </div>
  )
}

export default StepHeader
